type Activity = { id: string; name: string };
type UpcomingEvent = {
  name: string;
  startTime: Date | string;
  activity: { id: string } | null;
};

const normalise = (value: string) =>
  ` ${value
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()} `;

/** Event titles identify the main activity when an event has several tags. */
export function selectRelevantActivity<T extends Activity>(
  activities: T[],
  upcoming: UpcomingEvent[],
): T | undefined {
  for (const event of upcoming.toSorted(
    (a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime(),
  )) {
    const title = normalise(event.name);
    const named = activities.find((item) =>
      title.includes(normalise(item.name)),
    );
    if (named) return named;
    const tagged = activities.find((item) => item.id === event.activity?.id);
    if (tagged) return tagged;
  }
  return activities[0];
}
